import { Component, h, Prop, Element } from "@stencil/core";

@Component({
  tag: "scs-teaser-cluster",
  styleUrl: "teaser-cluster.scss",
  shadow: true,
})
export class TeaserCluster {
  @Element() hostEl!: HTMLElement;

  /**
   * Maximum number of teasers to display from the slotted content.
   * If fewer teasers are slotted, all will be shown.
   */
  @Prop() teaserNumber: number = 4;

  /**
   * Layout configuration for the teaser cluster.
   * - "left": teasers aligned to the left
   * - "right": teasers aligned to the right
   * - "half": teasers split in half layout
   */
  @Prop() layout: "left" | "right" | "half" = "half";

  componentDidLoad() {
    this.applyTeaserLimit();
  }

  componentDidUpdate() {
    this.applyTeaserLimit();
  }

  private applyTeaserLimit() {
    // Get all direct children of the host element (light DOM)
    const children = Array.from(this.hostEl.children) as HTMLElement[];

    // Filter to only include scs-teaser elements
    const teasers = children.filter(
      el => el.tagName.toLowerCase() === "scs-teaser",
    );

    // Remove teasers beyond the limit from the DOM
    teasers.forEach((teaser, index) => {
      if (index >= this.teaserNumber) {
        teaser.remove();
      }
    });
  }

  render() {
    const isFourTeaserHalfLayout =
      this.teaserNumber === 4 && this.layout === "half";

    return (
      <div
        class="teaser-cluster"
        data-layout={this.layout}
        data-teaser-number={this.teaserNumber}
      >
        {isFourTeaserHalfLayout && window.innerWidth >= 768 ? (
          <div class="teaser-cluster__container">
            <div class="teaser-cluster__column">
              <slot name="teaser-1"></slot>
              <slot name="teaser-2"></slot>
            </div>
            <div class="teaser-cluster__column">
              <slot name="teaser-3"></slot>
              <slot name="teaser-4"></slot>
            </div>
          </div>
        ) : (
          <div class="teaser-cluster__container">
            <slot></slot>
          </div>
        )}
      </div>
    );
  }
}
